import React from "react";
import "./App.css";
import { usePaths } from "./BEDROCK/paths";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthPage } from "BEDROCK/pages/auth/supabase/auth-page";
import { ResetPasswordPage } from "BEDROCK/pages/auth/supabase/reset-password-page";
import { ProtectedRoute } from "BEDROCK/auth/projected-route";
import { MyAccountPage } from "my-account/my-account-page";
import { AdminUsersPage } from "BEDROCK/pages/admin/admin-users-page";
import { AdminOrdersPage } from "BEDROCK/pages/admin/admin-orders-page";
import { AdminOrderDetailPage } from "BEDROCK/pages/admin/admin-order-detail-page";
import { AdminProductsPage } from "BEDROCK/pages/admin/admin-products-page";
import { Dashboard1 } from "BEDROCK/pages/admin/dashboard-1";
import { TermsPage } from "info-pages/terms";
import { PrivacyPage } from "info-pages/privacy";
import { CookiesPage } from "info-pages/cookies";

function App() {
  const paths = usePaths();

  return (
    <Routes>
      <Route
        path={paths.home}
        element={
          <ProtectedRoute>
            <Dashboard1 />
          </ProtectedRoute>
        }
      />
      <Route path={paths.auth} element={<AuthPage />} />
      <Route
        path={paths.resetPassword}
        element={
          <ProtectedRoute>
            <ResetPasswordPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.myAccount}
        element={
          <ProtectedRoute>
            <MyAccountPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.users}
        element={
          <ProtectedRoute>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.orders}
        element={
          <ProtectedRoute>
            <AdminOrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:orderId"
        element={
          <ProtectedRoute>
            <AdminOrderDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.products}
        element={
          <ProtectedRoute>
            <AdminProductsPage />
          </ProtectedRoute>
        }
      />
      <Route path={paths.terms} element={<TermsPage />} />
      <Route path={paths.privacyPolicy} element={<PrivacyPage />} />
      <Route path={paths.cookiePolicy} element={<CookiesPage />} />
    </Routes>
  );
}

export default App;
